import React, { useState } from "react";
import { servicesData } from "@data/servicesData";
import './services.css'

const Services = () => {
    const [ToggleState, setToggleState] = useState(-1);

    const toggleTab = (index) => {
        setToggleState(index);
    };
    return (
        <section className="services section" id="services">
            <h2 className="section__title">Expertise</h2>
            <span className="section__subtitle">Areas I Specialize In</span>

            <div className="services__container container grid">

                {servicesData.map((service, serviceIndex) => (
                    <div key={service.id} className="services__content">
                        <div>
                            <i className="uil uil-web-grid services__icon"></i>
                            <h3 className="services__title" dangerouslySetInnerHTML={{ __html: service.title }}></h3>
                        </div>
                        <span className="services__button" onClick={() => toggleTab(serviceIndex)}>
                            View More <i className={`uil uil-arrow-right services__button-icon ${ToggleState === serviceIndex ? 'rotate-icon' : ''}`}></i>
                        </span>

                        <div className={ToggleState === serviceIndex ? 'services__modal active-modal' : 'services__modal'}>
                            <div className="services__modal-content">
                                <i onClick={() => toggleTab(null)} className="uil uil-times services__modal-close"></i>

                                <h3 className="services__modal-title">{service.modalTitle}</h3>
                                <p className="services__modal-description">{service.modalDescription}</p>

                                <ul className="services__modal-services grid">
                                    {service.modalList.map((item, itemIndex) => (
                                        <li key={itemIndex} className="services__modal-service">
                                            <i className="uil uil-check-circle services__modal-icon"></i>
                                            <p className="services__modal-info">{item}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Services;